export { SEOFaqSection, SEODefinitions, SEOStats } from './SEOFaqSection';

export function useSEOData() {
  if (typeof window === 'undefined') return null;
  const api = (window as any).BOAT_TRADER_API;
  return api?.seo || null;
}